import React, { FunctionComponent } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TableChart from '@mui/icons-material/TableChart';
import { useSelector } from 'react-redux';
import { getTopLevelUserGroup } from 'application/redux/selectors';
import { getIsLumenRole } from 'helpers/roles';
import PdfNavItem from './PdfNavItem';

const BrUWGuidelinesInfo: FunctionComponent = () => {
    const group = useSelector(getTopLevelUserGroup);

    return (
        <>
            <PdfNavItem
                fileName="Lumen UW BR Guidelines - Oct-2025.pdf"
                navItemTitle="UW Guidelines"
                icon={<AssignmentIcon />}
            />
            <PdfNavItem
                fileName="Lumen UW BR Guidelines - Oct-2025.pdf"
                navItemTitle="Aggregation Guidelines"
                initialPageNumber={18}
                icon={<AssignmentIcon />}
            />
            <PdfNavItem
                fileName="Lumen UW BR Guidelines - Oct-2025.pdf"
                navItemTitle="UW Rate Table"
                initialPageNumber={19}
                icon={<TableChart />}
            />
        </>
    );
};

export default BrUWGuidelinesInfo;
